import React, { useEffect, useState } from "react";
import {
  Airplay,
  ChevronLeft,
  Eye,
  Feather,
  Menu,
  Play,
  Target,
} from "react-feather";
import { Link, useLocation } from "react-router-dom";
import { useToast } from "../Components/toast/ToastProvider";
import {
  getVehicleAdvanceByDate,
  saveVehicleAdvance,
} from "../Service/VehicleAdvanceService";
import { getAllVehicles } from "../Service/VehicleService";
import Sidebar from "./Sidebar";
import Modal from "../Components/Modal";
import VehicleAdvanceForm from "../Components/VehiceAdvanceForm";
import { Button } from "react-bootstrap";
import Footer from "../Components/Footer";

const VehicleAdvance = ({ handleLogout }) => {
  const [showSideBar, setShowSideBar] = useState(false);
  const [date, setDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });
  const [vehicles, setVehicles] = useState([]);
  const toast = useToast();
  const emptyRow = () => ({
    vehicle_number: "",
    amount: "",
    filteredVehicle: [],
    showVehicleList: false,
    highlightedVehicleIndex: -1,
  });

  const ROW_COUNT = 50;
  const [rows, setRows] = useState(Array.from({ length: ROW_COUNT }, emptyRow));

  const [page, setPage] = useState(0); // batch index
  const [showForm, setShowForm] = useState(false);

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    fetchVehicles();
  }, []);

  useEffect(() => {
    if (date && vehicles.length > 0) {
      fetchAllVehiclesAdvance(date);
    }
  }, [date, vehicles]);

  const fetchVehicles = async () => {
    try {
      const res = await getAllVehicles();
      setVehicles(res.data);
    } catch (err) {
      toast(err.message || "Failed to Fetch Vehicles", "ERROR");
    }
  };

  const handleAddRows = () => {
    setRows(Array.from({ length: ROW_COUNT }, emptyRow));
    setPage((prev) => prev + 1);
  };

  // const fetchAllVehiclesAdvance = async (selectedDate) => {
  //   try {
  //     const res = await getVehicleAdvanceByDate(selectedDate);
  //     const data = res.data || [];

  //     // if (data.length === 0) {
  //     //   setRows([]);
  //     //   toast("No vehicle advance found", "ERROR");
  //     //   return;
  //     // }

  //     const formatted = data.map((adv) => ({
  //       vehicle_id: adv.vehicle_id,
  //       vehicle_number: adv.vehicle_number,
  //       amount: Number(adv.amount).toFixed(2),
  //     }));

  //     setRows(formatted);
  //   } catch (err) {
  //     toast(err.message || "Failed to Fetch Vehicle Advance", "ERROR");
  //   }
  // };

  const fetchAllVehiclesAdvance = async (selectedDate) => {
    try {
      const res = await getVehicleAdvanceByDate(selectedDate);
      const data = res.data || [];

      if (data.length === 0) {
        setRows(Array.from({ length: ROW_COUNT }, () => ({ ...emptyRow })));
        return;
      }

      const filledRows = data.map((adv) => {
        const vehicle = vehicles.find((v) => v.id === adv.vehicle_id);
        return {
          vehicle_id: adv.vehicle_id,
          vehicle_number: vehicle ? vehicle.vehicle_number : "",
          amount: Number(adv.amount).toFixed(2),
          filteredVehicle: [],
          highlightedVehicleIndex: -1,
          showVehicleList: false,
        };
      });
      const paddedRows = [
        ...filledRows,
        ...Array.from({ length: ROW_COUNT - filledRows.length }, () => ({
          ...emptyRow,
        })),
      ];

      setRows(paddedRows);
    } catch (err) {
      toast(err.message || "Failed to Fetch VehicleAdvance", "ERROR");
    }
  };
  const handleChange = (index, field, value) => {
    const updated = [...rows];
    updated[index][field] = value;
    setRows(updated);
  };

  // const handleAddRows = () => {
  //   setRows([
  //     ...rows,
  //     {
  //       vehicle_id: "",
  //       vehicle_number: "",
  //       amount: "",
  //       filteredVehicle: [],
  //       highlightedVehicleIndex: -1,
  //       showVehicleList: false,
  //     },
  //   ]);
  // };

  const handleVehicleChange = (index, e) => {
    const input = e.target.value;
    const updated = [...rows];
    updated[index].vehicle_number = input;
    if (input.trim() === "") {
      updated[index].filteredVehicle = [];
      updated[index].showVehicleList = false;
      updated[index].vehicle_id = "";
      updated[index].highlightedVehicleIndex = -1;

      setRows(updated);
      return;
    }

    const filtered = vehicles.filter((v) =>
      v.vehicle_number.toLowerCase().includes(input.toLowerCase())
    );
    updated[index].filteredVehicle = filtered;
    updated[index].showVehicleList = true;
    updated[index].highlightedVehicleIndex = -1;

    const existingVehicle = vehicles.find(
      (v) => v.vehicle_number.toLowerCase() === input.toLowerCase()
    );
    updated[index].vehicle_id = existingVehicle ? existingVehicle.id : "";

    setRows(updated);
  };

  const handleVehicleSelect = (index, vehicle) => {
    const updated = [...rows];
    updated[index].vehicle_number = vehicle.vehicle_number;
    updated[index].vehicle_id = vehicle.id;
    updated[index].filteredVehicle = [];
    updated[index].showVehicleList = false;
    updated[index].highlightedVehicleIndex = -1;
    setRows(updated);

    setTimeout(() => focusAmountField(index), ROW_COUNT);
  };

  const focusNextField = (index) => {
    const nextIndex = index + 1;
    if (nextIndex >= rows.length) return;

    const nextInput = document.getElementById(`vehicle-${nextIndex}`);
    if (nextInput) nextInput.focus();
  };

  const focusAmountField = (index) => {
    const amountInput = document.getElementById(`amount-${index}`);
    if (amountInput) amountInput.focus();
  };

  const handleKeyDown = (index, e) => {
    const updated = [...rows];
    const { filteredVehicle, highlightedVehicleIndex, showVehicleList } =
      updated[index];

    if (showVehicleList && filteredVehicle.length > 0) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        updated[index].highlightedVehicleIndex =
          highlightedVehicleIndex < filteredVehicle.length - 1
            ? highlightedVehicleIndex + 1
            : 0;
        setRows(updated);
        return;
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        updated[index].highlightedVehicleIndex =
          highlightedVehicleIndex > 0
            ? highlightedVehicleIndex - 1
            : filteredVehicle.length - 1;
        setRows(updated);
        return;
      }

      if (e.key === "Enter") {
        e.preventDefault();
        if (highlightedVehicleIndex >= 0) {
          handleVehicleSelect(index, filteredVehicle[highlightedVehicleIndex]);
          return;
        }
      }
    }

    if (e.key === "Enter") {
      e.preventDefault();
      focusNextField(index);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const records = rows
        .filter((r) => r.vehicle_id && r.amount !== "")
        .map((r) => ({ ...r, date, amount: Number(r.amount).toFixed(2) }));

      if (records.length === 0) {
        toast("Please fill all fields", "ERROR");
        return;
      }
      await saveVehicleAdvance(records);
      toast("Vehicle advance saved successfully", "SUCCESS");
      setShowForm(false);
      await fetchAllVehiclesAdvance(date);
      setRows(Array.from({ length: ROW_COUNT }, emptyRow));

      const updated = rows.map((r) => {
        const found = records.find((rec) => rec.vehicle_id === r.vehicle_id);
        return found ? { ...r, amount: found.amount } : r;
      });
      setRows(updated);
    } catch (err) {
      console.error(err);
      toast("Failed to save record", "ERROR");
    }
  };
  const handleAddClick = () => {
    // setRows(Array.from({ length: ROW_COUNT }, emptyRow));
    setShowForm(true);
  };

  return (
    <div className="fixed-bottom-bar">
      <div className="osahan-trending">
        {/* Header */}
        <div className="bg-primary border-bottom p-3">
          <div className=" d-flex align-items-center justify-content-between">
            <Link to="/" className="text-white font-weight-bold">
              <ChevronLeft /> Back
            </Link>
            <Link className="toggle">
              <span
                className="toggle"
                onClick={() => setShowSideBar(true)}
                style={{ cursor: "pointer" }}
              >
                <Menu size={30} color="white" />
              </span>
            </Link>
          </div>
          <h2 className="font-weight-bold pt-3 m-0 text-white">
            Vehicle Advance
          </h2>
        </div>

        <div className="d-flex justify-content-end mt-3 px-3">
          <Button
            variant="secondary"
            size="sm"
            style={{ outline: "none", border: "none" }}
            onClick={handleAddClick}
          >
            Add
          </Button>
        </div>

        <Modal
          visible={showForm}
          size="md"
          headerText={"vehicleAdvance"}
          onClose={async () => {
            setShowForm(false);
            await fetchAllVehiclesAdvance(date);
          }}
        >
          <VehicleAdvanceForm
            rows={rows}
            handleAddRows={handleAddRows}
            handleChange={handleChange}
            handleSave={handleSave}
            handleVehicleChange={handleVehicleChange}
            handleVehicleSelect={handleVehicleSelect}
            handleKeyDown={handleKeyDown}
            ROW_COUNT={ROW_COUNT}
            setRows={setRows}
          />
        </Modal>

        <div className="mt-3 p-3">
          <input
            type="date"
            className="form-control"
            value={date}
            name="date"
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        {/* Trending Cards */}
        <div className="most_popular p-3">
          <div className="row justify-content-center">
            {rows.map((row, index) => {
              const vehicleNumber = vehicles.find(
                (v) => v.id === row.vehicle_id
              );
              return (
                row.vehicle_id && (
                  <div
                    className="col-12 d-flex justify-content-center mb-3"
                    key={index}
                  >
                    <div className="card shadow-sm bill-card border-0 text-center">
                      <div className="card-body p-3">
                        <h5 className="fw-bold text-muted">
                          {vehicleNumber?.vehicle_number}
                        </h5>

                        <hr className="my-2" />

                        <small className="text-muted"> Amount</small>
                        <h6 className="text-success fw-bold mt-1">
                          ₹ {row.amount}
                        </h6>
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </div>
        </div>

        {/* Sidebar */}
        <Sidebar
          showSideBar={showSideBar}
          setShowSideBar={setShowSideBar}
          onLogout={handleLogout}
        />

        {/* Footer */}
      <Footer />
      </div>
    </div>
  );
};

export default VehicleAdvance;
